import { createSlice } from '@reduxjs/toolkit';
import { TMortrageState } from 'shared/types/mortrage';

const initialState: TMortrageState = {
  psk: '',
  mortgageRateDiscount: 0,
  downPaymentRate: 0,
  objectPriceRateDiscount: 0,
  baseRate: 0,
  subsidizedRate: 0,
  disclaimer: '',
};

/* istanbul ignore next */
const mortrageSlice = createSlice({
  initialState,
  name: 'mortrageInfo',
  reducers: {},
});

export const { reducer: mortrageReducer } = mortrageSlice;
